(function () {
  var FETCH_TIMEOUT_MS = 6000;

  document.querySelectorAll('.js-b2b-signup-form').forEach(function (form) {
    var submitButton = form.querySelector('.b2b_signup_form_submit');
    if (!submitButton) return;

    var eanInput = form.querySelector('[name="contact[EAN-nummer]"]');
    if (eanInput) {
      eanInput.addEventListener('input', function () {
        eanInput.setCustomValidity('');
      });
    }

    submitButton.addEventListener('click', function () {
      if (form.dataset.fallbackInProgress === 'true') return;

      if (eanInput) {
        var ean = eanInput.value.trim();
        eanInput.setCustomValidity(ean && !isValidEan(ean) ? eanInput.dataset.invalidMessage || eanInput.title : '');
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var container = form.closest('.b2b_signup_form');
      var automationUrl = container && container.dataset.automationUrl;
      if (!automationUrl) {
        submitNatively(form);
        return;
      }

      var payload = buildPayload(form);
      submitButton.disabled = true;

      var controller = new AbortController();
      var timeoutId = setTimeout(function () {
        controller.abort();
      }, FETCH_TIMEOUT_MS);

      fetch(automationUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        signal: controller.signal,
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok && data.ok, data: data };
          });
        })
        .then(function (result) {
          clearTimeout(timeoutId);
          if (!result.ok) {
            submitNatively(form);
            return;
          }
          try {
            showSuccess(form);
          } catch (e) {}
        })
        .catch(function () {
          clearTimeout(timeoutId);
          submitNatively(form);
        });
    });
  });

  function isValidEan(value) {
    if (!/^\d{13}$/.test(value)) return false;
    var sum = 0;
    for (var i = 0; i < 12; i++) sum += Number(value[i]) * (i % 2 ? 3 : 1);
    return (10 - (sum % 10)) % 10 === Number(value[12]);
  }

  function buildPayload(form) {
    var data = new FormData(form);
    var get = function (name) {
      var value = data.get(name);
      return typeof value === 'string' ? value.trim() : '';
    };

    return {
      website: get('contact[website]'), // honeypot, always blank for real submissions
      companyName: get('contact[Virksomhedsnavn]'),
      cvr: get('contact[CVR-nummer]'),
      ean: get('contact[EAN-nummer]'),
      name: get('contact[name]'),
      email: get('contact[email]'),
      phone: get('contact[phone]'),
      billingStreet: get('contact[Faktureringsadresse - Gade og nr.]'),
      billingZip: get('contact[Faktureringsadresse - Postnr.]'),
      billingCity: get('contact[Faktureringsadresse - By]'),
      billingCountry: get('contact[Faktureringsadresse - Land]'),
      deliveryStreet: get('contact[Leveringsadresse - Gade og nr.]'),
      deliveryZip: get('contact[Leveringsadresse - Postnr.]'),
      deliveryCity: get('contact[Leveringsadresse - By]'),
      deliveryCountry: get('contact[Leveringsadresse - Land]'),
      comment: get('contact[body]'),
    };
  }

  function submitNatively(form) {
    form.dataset.fallbackInProgress = 'true';
    form.submit();
  }

  function showSuccess(form) {
    var container = form.closest('.b2b_signup_form');
    var successMessage = (container && container.dataset.successMessage) || 'Tak for din ansøgning.';

    var successEl = document.createElement('div');
    successEl.className = 'b2b_signup_form_success';
    successEl.setAttribute('tabindex', '-1');
    successEl.textContent = successMessage;

    form.innerHTML = '';
    form.appendChild(successEl);
    successEl.focus();
  }
})();
